<template>
    <dialog-generic :visibility.sync='visibility' :indicator='indicator'>
        <template v-slot:title> {{ dataSource.data_source_name }} </template>
        <template v-slot:content>
            <div class='py-2 text-center'>Удалить источник данных?</div>
        </template>
        <template v-slot:action>
            <v-btn class='px-0 red--text text--darken-2' :loading='indicator' block depressed @click='deleteDataSource'>
                Удалить
            </v-btn>
        </template>
    </dialog-generic>
</template>


<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue';
    export default {
        name: 'DataSourceDeleteDialog',
        props: ['data', 'postAction', 'projectId', 'initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                dataSource: this.data,
                indicator: false,
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            data(value) {
                this.dataSource = value
            }
        },
        methods: {
            deleteDataSource() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'id': this.dataSource.id
                }
                this.$http.patch(this.$store.getters.endpoint + '/db/project/' + this.projectId + '/datasources',
                    requestData,
                    {headers: {...this.$store.state.restrictedHeaders,...requestHeaders}}
                ).then( (r) => {
                    this.postAction('datasources')
                    this.visibility = false;
                    this.indicator = false;
                });
            }
        }
    }
</script>
